<div class="page-wrapper vendor-item-page-wrapper" perfectScrollbar>
  <dx-load-panel
    [hideOnOutsideClick]="false"
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="loading">
</dx-load-panel>
  <div fxLayout="column">
    <div class="flex-p">
        <div class="card">
            <div class="card-header justify-space-between d-flex align-items-center cursor-pointer">
                <h5 class="m-0"> Customer Contact Login</h5>
                <div class="cursor-pointer" >
                    <button style="height: 30px;line-height: 30px;"  mat-icon-button [routerLink]="[ '/portal/customers/customer-contact-login/create']">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
  </div>

  <div fxLayout="column">
      <div class="flex-p">
          <dx-data-grid id="gridContainer10" [dataSource]="dataSource" 
          [columnAutoWidth]="true" [showBorders]="true" [wordWrapEnabled]="true">
          <dxo-paging [pageSize]="10"></dxo-paging>
          <dxo-pager 
              [showPageSizeSelector]="true"
              [allowedPageSizes]="[5, 10, 20]"
              [showInfo]="true">
          </dxo-pager>
          <dxo-filter-row [visible]="true" ></dxo-filter-row>
          <dxo-header-filter [visible]="true"></dxo-header-filter>
          <dxi-column dataField="customerId" caption="Customer ID" [width]="130" cssClass="text-center"></dxi-column>
          <dxi-column dataField="userName" caption="User Name"></dxi-column>
          <dxi-column dataField="userPassword" caption="Password"></dxi-column>
          <dxi-column dataField="isAdmin" caption="Role" [width]="80" cssClass="text-center" cellTemplate="isAdminTemplate" [allowFiltering]="false"></dxi-column>
          <dxi-column dataField="active" caption="Status" [width]="80" cssClass="text-center" cellTemplate="statusTemplate" [allowFiltering]="false"></dxi-column>
          <dxi-column caption="Actions" [width]="100"  cssClass="text-center" cellTemplate="actionTemplate" [allowFiltering]="false"></dxi-column>
          <div class="employee dx-row" *dxTemplate="let d of 'isAdminTemplate'">
            <div class="main-row">
              <!--  [ngClass]="d.data.isAdmin ? 'text-green' : 'text-red'" -->
                <span>{{d.data.isAdmin ? 'Admin' : 'User'}}</span>
            </div>
          </div>
          <div class="employee dx-row" *dxTemplate="let d of 'statusTemplate'">
            <div class="main-row">
                <span [ngClass]="d.data.active ? 'text-green' : 'text-red'">{{d.data.active ? 'Active' : 'Inactive'}}</span>
            </div>
          </div>
          <div *dxTemplate="let data of 'actionTemplate'">
              <button mat-icon-button color="primary"
              [routerLink]="[ '/portal/customers/customer-contact-login/edit', data.data.customerContactLoginId ]">
              <mat-icon>edit</mat-icon>
            </button>
            <button type="button" mat-icon-button *ngIf="data.data.active" matTooltip="Delete Item" [swal]="deleteSwal">
              <mat-icon color="warn">delete</mat-icon>
            </button>
            <swal #deleteSwal title="Are you sure want to delete ?" text="This cannot be undone" type="question"
              [showCancelButton]="true" [focusCancel]="true"
              (confirm)="deleteCustomerContactLogin(data.data.customerContactLoginId)">
            </swal>
          </div>
        </dx-data-grid>
      </div>
    </div>

</div>
<swal #saveSwal></swal>
